import { useEffect } from "react";

export interface MetaInput {
  title: string;
  description: string;
}

/**
 * 在组件内动态更新页面 title 与 meta description，
 * 并设置指向当前页面的 canonical 与 Open Graph / Twitter 基础标签。
 */
export default function useDocumentMeta({ title, description }: MetaInput) {
  useEffect(() => {
    document.title = title;

    const setMeta = (attr: "name" | "property", key: string, content: string) => {
      let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const canonical = `${window.location.origin}${window.location.pathname}`;
    setMeta("name", "description", description);

    let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);

    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonical);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
  }, [title, description]);
}